import { Component, OnDestroy, OnInit } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import { CommonService } from './core/common/services/common.service';
import { MsalBroadcastService, MsalService } from '@azure/msal-angular';
import { AuthenticationResult, EventMessage, EventType } from '@azure/msal-browser';
import { Subject, filter, takeUntil } from 'rxjs';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'tandc-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit, OnDestroy {
  title = 'Tests and Certificates';
  private readonly _destroying$ = new Subject<void>();

  constructor(public translate: TranslateService,public commonService: CommonService,
        private authService: MsalService,
        private msalBroadcastService: MsalBroadcastService,
        private router: Router,
        private route: ActivatedRoute,
        private titleService: Title){
    translate.addLangs(['en']);
    translate.setDefaultLang("en");
  }

  ngOnInit(): void {
    this.msalBroadcastService.msalSubject$
        .pipe(
            filter((msg: EventMessage) => msg.eventType === EventType.LOGIN_SUCCESS),
            takeUntil(this._destroying$)
        )
        .subscribe((result: EventMessage) => {
            //console.log(result);
            const payload = result.payload as AuthenticationResult;
            this.authService.instance.setActiveAccount(payload.account);
        });
    
    this.router.events
    .pipe(filter(event => event instanceof NavigationEnd))
    .subscribe(() => {
      let currentRoute = this.route;

      while (currentRoute.firstChild) {
        currentRoute = currentRoute.firstChild;
      }

      const prefix = currentRoute.snapshot.data['prefix'];
      const id = currentRoute.snapshot.params['id'];

      if (prefix && id) {
        this.titleService.setTitle(`TESCA ${prefix}-${id}`);
      } else {
        this.titleService.setTitle('TESCA');
      }
    });
  }

  ngOnDestroy(): void {
    this._destroying$.next(undefined);
    this._destroying$.complete();
  }

}
